
export const generateCategoryUrl = (subCatName, subCatId, masCatId) => {
    let catObjUrl = `/${subCatName
        .toLowerCase()
        .trim()
        .replace(/ /g, "-")}-c-${subCatId}-mc-${masCatId
        }`;
    return catObjUrl;
}